import React, { useState, useEffect, useContext } from "react"
import api from "../../services/api"
import { AuthContext } from "../../context/Auth/AuthContext"
import { Grid } from "@material-ui/core"
import { toast } from "react-toastify"
import DefaultButton from "../DefaultButton"
import useStyles from "./styles"
import Modal from "../Modal"
import { DadosContato } from "./components/dadosContato"
import { InfoContato } from "./components/infoContato"
import { conversaContatoMotivos } from "../../utils/conversaContatoMotivos"
import ContactAutocomplete from "./components/Autocomplete/ContactAutocomplete"
import QueueAutocomplete from "./components/Autocomplete/QueueAutocomplete"
import MotivoAutocomplete from "./components/Autocomplete/MotivoAutocomplete"
import WhatsappAutocomplete from "./components/Autocomplete/WhatsappAutocomplete"
import { canais } from "../../utils/canais"

function formatErrorMessage(message) {
  return message.replace(/\n/g, "<br>")
}

const { COMUNICACAO } = conversaContatoMotivos

const { whatsapp, interno } = canais

const ConfirmacaoNovaConversaModal = ({ modalOpen, onClose, initialContact }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)
  const [selectedQueue, setSelectedQueue] = useState("")
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("")
  const [motivoContatoId, setMotivoContatoId] = useState(COMUNICACAO)
  const { user } = useContext(AuthContext)

  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setSelectedContact(initialContact)
    }
  }, [initialContact])

  useEffect(() => {
    if (modalOpen) {
      setSelectedQueue(user?.queues[0]?.id)
    }
  }, [modalOpen, user])

  const handleSaveTicket = async (oContatoSelecionado) => {
    if (!oContatoSelecionado) return

    // Determina se é conversa interna baseado no canalTipoId
    const lEhConversaInterna = oContatoSelecionado?.canalTipoId === interno

    if (selectedQueue === "" && user.profile !== "admin") {
      toast.error("Selecione uma fila")
      return
    }

    if (motivoContatoId === "") {
      toast.error("Selecione um Motivo do Contato")
      return
    }

    // Para WhatsApp, conexão é obrigatória
    const lCanalWhatsApp = oContatoSelecionado?.canalTipoId === whatsapp
    if (lCanalWhatsApp && selectedWhatsapp === "") {
      toast.error("Selecione uma conexão")
      return
    }

    setLoading(true)
    try {
      const queueId = selectedQueue !== "" ? selectedQueue : null
      const canalId = lCanalWhatsApp ? (selectedWhatsapp !== "" ? selectedWhatsapp : null) : null

      // Monta o payload baseado no tipo de conversa
      const oPayload = {
        queueId,
        canalId,
        canalTipoId: oContatoSelecionado?.canalTipoId || whatsapp,
        responsavelId: user.id,
        status: "open",
        motivoContatoId,
      }

      // Para conversas internas, envia usuarioId
      // Para conversas externas, envia contactId
      if (lEhConversaInterna) {
        oPayload.usuarioId = oContatoSelecionado.id
      } else {
        oPayload.contactId = oContatoSelecionado.id
      }

      try {
        const { data: ticket } = await api.post("/tickets", oPayload)
        onClose(ticket)
      } catch (err) {
        if (err.response && err.response.data) {
          const formattedMessage = formatErrorMessage(err.response.data.error)
          toast.error(<div dangerouslySetInnerHTML={{ __html: formattedMessage }} />)
        } else {
          toast.error("Erro ao criar conversa")
        }
      }
    } catch (err) {
      toast.error(JSON.parse(err.response.data.error))
    }
    setLoading(false)
  }

  const cleanFunc = () => {
    setSelectedContact(null)
    setSelectedQueue(user?.queues[0]?.id)
    setMotivoContatoId(COMUNICACAO)
    setSelectedWhatsapp(user?.whatsappId || "")
  }

  const renderFooter = () => {
    return (
      <div className={classes.buttonsContainer}>
        <DefaultButton
          stylization="primary"
          className={classes.btnFullWidth}
          disabled={!selectedContact}
          loading={loading}
          onClick={() => handleSaveTicket(selectedContact)}
        >
          Iniciar conversa
        </DefaultButton>
      </div>
    )
  }

  return (
    <>
      <Modal
        infoContato={<InfoContato initialContact={initialContact} />}
        dadosContato={<DadosContato initialContact={initialContact} />}
        modalOpen={modalOpen}
        onClose={onClose}
        cleanFunc={cleanFunc}
        footer={renderFooter()}
      >
        {modalOpen && initialContact && initialContact.canalTipoId !== interno && (
          <Grid style={{ float: "right" }} container>
            {/* CONTATO */}
            <ContactAutocomplete
              initialContact={initialContact}
              onContactSelect={setSelectedContact}
              selectedContact={selectedContact}
              loading={loading}
              setLoading={setLoading}
            />

            {/* FILA */}
            <QueueAutocomplete selectedQueue={selectedQueue} onQueueSelect={setSelectedQueue} />

            {/* MOTIVO */}
            <MotivoAutocomplete motivoContatoId={motivoContatoId} onMotivoSelect={setMotivoContatoId} />

            {/* CONEXÃO */}
            <WhatsappAutocomplete selectedWhatsapp={selectedWhatsapp} onWhatsappSelect={setSelectedWhatsapp} />
          </Grid>
        )}
      </Modal>
    </>
  )
}

export default ConfirmacaoNovaConversaModal
